// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Components
import StepProgress from 'components/Onboarding/StepProgress/StepProgress'
import Subscriptions from 'pages/Onboarding/Usage/Subscriptions'

// Assets
import { ReactComponent as Logo } from 'assets/icons/logo_clicktech.svg'

// Styles
import classes from 'pages/Onboarding/Onboarding.module.scss'

const Usage = () => {
  return (
    <>
      <div className={clsx(classes.usageStepContainer)}>
        <div className={clsx(classes.stepAction)}>
          <div className={clsx(classes.stepSection, 'mt-2', 'mt-xl-up-5')}>
            <div className={clsx(classes.logo)}>
              <Logo/>
            </div>
          </div>
          <div className={clsx(classes.stepSection)}>
            <div className={clsx(classes.stepProgress)}>
              <StepProgress step={1} label="account" theme="complete" className="d-none-sm"/>
              <StepProgress step={2} label="profile" theme="complete" className="d-none-sm"/>
              <StepProgress step={3} label="usage" theme="active"/>
              <StepProgress step={4} label="connect" theme="pending"/>
            </div>
          </div>
        </div>
      </div>
      <div className={clsx(classes.usageContainer)}>
        <Subscriptions/>
      </div>
    </>
  )
}

export default Usage
